import React from 'react';

import styled from '@emotion/styled';

import Img from '../Img/Img';
// import { ToggleButton } from '../ToggleButton/ToggleButton';

interface IPostedJobsCard {
  imgSrc: string;
  title: string;
  email: string;
  contact: string;
}

const LocumContactsCard: React.FC<IPostedJobsCard> = ({
  imgSrc,
  title,
  email,
  contact,
}) => {
  return (
    <Container>
      <div>
        {' '}
        <ImageContainer>
          <Img src={imgSrc} alt="shift location image" />
        </ImageContainer>
        <Up>
          <UpperSectionTitle>{title}</UpperSectionTitle>
          <UpperSectionDescription>{email}</UpperSectionDescription>
        </Up>
      </div>
      <Contact>
        <p>Contact Locum</p>
      </Contact>
      {/* <ToggleButton controller={() => console.log('Toggle')} /> */}

      {/* <BottomSection>
        <FlexContainer>
          <BottomSectionLabel>Contract Period</BottomSectionLabel>
          <BottomSectionLabel>Pay</BottomSectionLabel>
        </FlexContainer>
        <FlexContainer>
          <BottomSectionData>{contact}</BottomSectionData>
        </FlexContainer>
      </BottomSection> */}
    </Container>
  );
};

export default LocumContactsCard;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  items: center;
  color: black;
  // border-radius: 0.25rem;
  // background-color: ${({ theme }) => theme.palette.backgroundColor};

  div:nth-of-type(1) {
    display: flex;
    gap: 0.5rem;
  }
`;

const Up = styled.div`
  display: flex;
  flex-direction: column;
`;

const UpperSectionTitle = styled.div`
  font-size: 1.25rem;
  font-weight: 400;
  line-height: normal;
`;

const UpperSectionDescription = styled.div`
  font-size: 0.872rem;
  font-weight: 300;
  color: ${({ theme }) => theme.palette.greyGrey1};
`;
const ImageContainer = styled.div`
  width: 3.125rem;
  height: 3.125rem;
  height: fit-content;
  border-radius: 50%;
`;

const Contact = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.palette.mainBlue};
  font-weight: 500;
  font-size: 14px;
`;

// const BottomSection = styled.div`
//   display: flex;
//   flex-direction: column;
//   padding: 0.5rem 0.875rem;
//   border-top: 1px solid ${({ theme }) => theme.palette.borderColor};
// `;

// const BottomSectionLabel = styled.div`
//   font-size: 1.25rem;
//   font-weight: 400;
//   line-height: normal;
//   color: ${({ theme }) => theme.palette.greyGrey2};
// `;

// const BottomSectionData = styled.div`
//   font-size: 1.25rem;
//   font-weight: 400;
//   line-height: normal;
//   color: ${({ theme }) => theme.palette.blackBlackMain};
// `;

// const FlexContainer = styled.div`
//   display: flex;
//   justify-content: space-between;
// `;
